<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import MobileNavigationBrand from './mobile-navigation-brand.vue';
import MobileNavigationBrandAccount from './mobile-navigation-brand-account.vue';
import AccountLogo from '@monolith/legacy/components/account/account-logo.vue';
import { AkNavigationItem } from '@ankorstore/design-system';
import { useStore } from '@client/monolith/core/composables/use-store';


defineProps<{
  brand: {
    name: string;
    link: string;
  };
  navigationItems: Array<AkNavigationItem>;
  opened: boolean;
}>();

const route = useRoute();
const store = useStore();

const isBrandCandidate = computed(() => {
  return store.getters['userIsCandidateBrand'];
});

const navigateTo = (path) => {
  window.location.href = path;
};

const brandAccount = route.path.includes('/account/');
</script>

<template>
  <div class="mobile-navigation">
    <hr>
    <div class="mobile-navigation__item">
      <a
        class="mobile-navigation__logo"
        :href="brand.link"
      >
        <AccountLogo size="60" />
        <span class="mobile-navigation__brand-name">{{ brand.name }}</span>
      </a>
    </div>
    <hr v-if="!brandAccount">
    <div
      v-if="!brandAccount"
      class="mobile-navigation__item"
    >
      <AkButton
        class="mobile-navigation__button"
        color="white"
        size="md"
        type="button"
        symbol="arrow-right"
        @click="navigateTo(isBrandCandidate? '/v2/account/products': '/account')"
      >
        {{ $t('shared.menu.gotoyouraccount') }}
      </AkButton>
    </div>
    <hr v-if="brandAccount">
    <div
      v-if="brandAccount"
      class="mobile-navigation__item"
    >
      <AkButton
        class="mobile-navigation__button"
        color="white"
        size="md"
        type="button"
        symbol="arrow-right"
        @click="navigateTo('/')"
      >
        {{ $t('shared.menu.gotomarketplace') }}
      </AkButton>
    </div>
    <hr>
    <div v-if="!brandAccount">
      <MobileNavigationBrand
        :navigation-items="navigationItems"
        :opened="opened"
      />
    </div>
    <div v-if="brandAccount">
      <MobileNavigationBrandAccount />
    </div>
    <hr>
    <div class="mobile-navigation__item">
      <AkButton
        class="mobile-navigation__button"
        color="white"
        size="md"
        type="button"
        symbol="power"
        @click="navigateTo('/logout')"
      >
        {{ $t('shared.menu.logout') }}
      </AkButton>
    </div>
  </div>
</template>

<style scoped lang="scss">
.mobile-navigation {
  &__item {
    @apply ds-py-2;
  }
  &__logo {
    @apply ds-flex ds-gap-4;
    align-items: center;
  }
  &__button {
    @apply ds-p-0 !important;
  }
}
</style>
